<template>
  <div class="m-0 dbozone-font bg" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="game-title" :class="`-${lang} `">{{ $t('oneboxing.name') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.paytable') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des" :class="`-${lang} `">{{ $t('oneboxing.paytable-des') }}</h5>
      </div>

      <div class="paytable-bg">
        <div class=" align-items-center mb-5">
          <div class=" align-items-center justify-content-center d-flex">
            <img :src="require(`../../assets/resultGame/oneboxing/s_10.png`)" alt="scatter-symbol"
              class="special-symbol-image" />
            <img :src="require(`../../assets/resultGame/oneboxing/s_11.png`)" alt="scatter-symbol"
              class="special-symbol-image" />
          </div>
          <div style="margin-left: 11%;">
            <div class="payouts">
              <div v-for="(key) in Object.keys(symbols[0].payouts).map(Number).sort((a, b) => b - a)" :key="key"
                class="payout-row">
                <span class="sub-text-gray-payout" :style="getDynamicMargin(symbols[0].id)">{{ key
                }}&nbsp;&nbsp;-</span>
                <span class="sub-text-payout">{{ symbols[0].payouts[key] }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class=" align-items-center">
          <div class=" align-items-center justify-content-center d-flex">
            <img :src="require(`../../assets/resultGame/oneboxing/s_9.png`)" alt="scatter-symbol"
              class="special-symbol-image" />
            <img :src="require(`../../assets/resultGame/oneboxing/s_9_1.png`)" alt="scatter-symbol"
              class="special-symbol-image" />
          </div>
          <div>
            <div class="payouts">
              <div class="payout-row">
                <span class="sub-text-gray-payout" :style="getDynamicMargin(symbols[9].id)">{{ 6
                }}&nbsp;&nbsp;-</span>
                <span class="sub-text-payout">{{ symbols[1].payouts[6] }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-container">
          <div v-for="(symbol, index) in symbols" :key="index" class="grid-item">
            <div v-if="symbol.id >= 1 && symbol.id <= 8">
              <img :src="symbol.image" class="symbol-image" alt="symbol" />
              <div class="payouts">
                <div v-for="(key) in Object.keys(symbol.payouts).map(Number).sort((a, b) => b - a)" :key="key"
                  class="payout-row">
                  <span class="sub-text-gray-payout" :style="getDynamicMargin(symbol.id)">{{ key
                  }}&nbsp;&nbsp;-</span>
                  <span class="sub-text-payout">{{ symbol.payouts[key] }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class=" align-items-center">
          <div class=" align-items-center justify-content-center d-flex">
            <img :src="require(`../../assets/resultGame/oneboxing/s_0.png`)" alt="symbol" class="symbol-image" />
          </div>
          <div style="margin-left: 4%;">
            <div class="payouts">
              <div v-for="(key) in Object.keys(symbols[10].payouts).map(Number).sort((a, b) => b - a)" :key="key"
                class="payout-row">
                <span class="sub-text-gray-payout" :style="getDynamicMargin(symbols[10].id)">{{ key
                }}&nbsp;&nbsp;-</span>
                <span class="sub-text-payout">{{ symbols[10].payouts[key] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.adjustment') }}</h5>
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 2" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`oneboxing.adjustment-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.gamefeature') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.scatter') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/freespin_feature.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 2" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`oneboxing.scatter-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.freespin_wheel') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/wheel_buyfeature_normal_info.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul>
            <li class="sub-text-list-gray">{{ $t(`oneboxing.random-free-multi`) }}</li>
            <li class="sub-text-list-gray">{{ $t(`oneboxing.random-free-spin`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.superspin_wheel') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/wheel_buyfeature_super_info.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul>
            <li class="sub-text-list-gray">{{ $t(`oneboxing.random-super-multi`) }}</li>
            <li class="sub-text-list-gray">{{ $t(`oneboxing.random-super-spin`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.freespin-retrigger') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/freespins_retrigger.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des" :class="`-${lang} `">{{ $t('oneboxing.freespin-retrigger-des') }}</h5>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.wild-symbol') }}</h5>
      </div>

      <ul>
        <li class="sub-text-list-gray">{{ $t(`oneboxing.wild-des1`) }}</li>
        <li class="sub-text-list-gray">{{ $t(`oneboxing.wild-des2`) }}</li>
      </ul>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/normal_wild_win.png`)" alt="multiplier"
          class="multiplier-image" />
      </div>

      <div class="d-flex pt-4 ml-3">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.normal-wild') }}</h5>
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`oneboxing.normal-wild-des`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/super_wild_win.png`)" alt="multiplier"
          class="multiplier-image" />
      </div>

      <div class="d-flex pt-4 ml-3">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.super-wild') }}</h5>
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`oneboxing.super-wild-des`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/super_wild_win_multiplier.png`)" alt="multiplier"
          class="multiplier-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`oneboxing.super-wild-effect1`) }}</li>
            <li class="sub-text-list-gray">{{ $t(`oneboxing.super-wild-effect1-2`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/super_wild_win_special_skill.png`)" alt="multiplier"
          class="multiplier-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`oneboxing.super-wild-effect2`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/super_wild_win_both.png`)" alt="multiplier"
          class="multiplier-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`oneboxing.super-wild-effect3`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des" :class="`-${lang} `">{{ $t('oneboxing.super-wild-effect4') }}</h5>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.featurebuy') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/feature_buy_${imgLang}.png`)" alt="feature-buy"
          class="feature-buy-image" />
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span>
          <ul class="symbol-info">
            <li v-for="(li, index) in 4" :key="index" class="sub-text-list-gray">{{ $t(`oneboxing.featurebuy-des${index
              + 1}`)
              .replace('MIN', currencyFormatterWithSymbol(betMinMax[0]))
              .replace('MAX', currencyFormatterWithSymbol(featureBuyMaximum)) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/buy_normal_${imgLang}.png`)" alt="feature-buy"
          class="feature-buy-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`oneboxing.featurebuy-des5`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/buy_super_${imgLang}.png`)" alt="feature-buy"
          class="feature-buy-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`oneboxing.featurebuy-des5`) }}</li>
            <li class="sub-text-list-gray">{{ $t(`oneboxing.featurebuy-des6`) }}</li>
            <li class="sub-text-list-gray">{{ $t(`oneboxing.featurebuy-des7`)
              .replace('MAX', currencyFormatterWithSymbol(featureBuyMaximum)) }}</li>
            <li class="sub-text-list-gray">{{ $t(`oneboxing.featurebuy-des8`) }}</li>
          </ul>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span class="justify-content-center align-items-center">
          <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.win-line') }}</h5>
        </span>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/win_paytable.png`)" alt="win-line"
          class="win-line-image" />
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span>
          <ul class="symbol-info">
            <li v-for="(li, index) in 3" :key="index" class="sub-text-list-gray">{{ $t(`oneboxing.win-line-des${index
              + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.gamerule') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/volality/volatility_${imgLang}.png`)" alt="slotmachine"
          class="volatility-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <h5 class="sub-text-gray text-des" :class="`-${lang} `">{{ $t('oneboxing.text-rule1') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/oneboxing/reel_area.png`)" alt="slotmachine"
          class="slotmachine-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <div v-for="(li, index) in 10" :key="index" class="sub-text-gray" :class="`-${lang} `">
            <li v-if="index + 1 != 5">
              {{ $t(`oneboxing.game-rule${index + 1}`)
                .replace('MIN', currencyFormatterWithSymbol(betMinMax[0]))
                .replace('MAX', currencyFormatterWithSymbol(betMinMax[1]))
                .replace('CUR', formattedCurrency) }}
            </li>
            <li v-else-if="index + 1 == 5 && isShowCurrencySymbol">
              {{ $t(`oneboxing.game-rule${index + 1}`)
                .replace('MIN', currencyFormatterWithSymbol(betMinMax[0]))
                .replace('MAX', currencyFormatterWithSymbol(betMinMax[1]))
                .replace('CUR', formattedCurrency) }}
            </li>
          </div>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-2 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.round') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <h5 class="sub-text-gray text-des" :class="`-${lang} `">{{ $t('oneboxing.round-des') }}</h5>
          <span v-for="(li, index) in 6" :key="index">
            <li v-if="index + 1 != 5" class="pb-2 [t-2 sub-text" :class="`-${lang} `">
              {{ $t(`oneboxing.round-title${index + 1}`) }}
              <span class="sub-text-gray" :class="`-${lang} `">{{ $t(`oneboxing.round-des${index + 1}`)
                }}</span>
            </li>
            <li v-else class="pb-2 [t-2 sub-text" :class="`-${lang} `">
              {{ $t(`oneboxing.round-title${index + 1}`) }}
              <span class="sub-text-gray" :class="`-${lang} `">{{ $t(`oneboxing.round-des${index + 1}`)
                }}</span>
              <span v-for="(lj, j) in 4" :key="j" class="sub-text-gray">
                <br>{{ $t(`oneboxing.round-des5-${j + 1}`) }}
              </span>
            </li>
          </span>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('main-game.title') }}</h5>
      </div>

      <table class="control-table">
        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/spin_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.spin-button') }}</h3>
            <li v-for="(li, index) in 4" :key="index" class="sub-text-gray">
              {{ $t(`main-game.spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/autospin_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.auto_spin-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/stop_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-round-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/betsize_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.bet-option-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.bet-option-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/turbo_on.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.turbo-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.turbo-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/info_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.gamerule-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.gamerule-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/additional_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.additional-menu') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.additional-menu-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/setting_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.settings') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.settings-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/history_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.history-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.history-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/home_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.back') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.back-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/icon_wallet.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.wallet-balance-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{
              $t(`main-game.wallet-balance-button-des${index + 1}`) }} </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/icon_refresh.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.refresh-balance-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.refresh-balance-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/icon_bet.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.bet-amount-button') }}</h3>
            <li v-for="(li, index) in 3" :key="index" class="sub-text-gray">{{
              $t(`main-game.bet-amount-button-des${index + 1}`) }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/oneboxing/icon_win.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.winnings-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{ $t(`main-game.winnings-button-des${index
              + 1}`) }}</li>
          </td>
        </tr>
      </table>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <u>
          <li class="sub-text-gray text-des" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional-des1') }}
          </li>
          <li class="sub-text-gray text-des" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional-des2') }}
          </li>
        </u>
      </div>

      <div class="p-3"></div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'rule',
  props: {
    data: Object,
    lang: String,
    imgLang: String,
    betMinMax: Array,
    currentBet: Number,
    featureBuyMaximum: Number,
    featureBuyMultiplier: Array,
    currency: String,
    isShowCurrencySymbol: Boolean,
  },
  data() {
    return {
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
      paytable: this.data.config.payTable,
      symbols: this.generateSymbols(),
    }
  },
  mounted() {
    this.generateSymbols();
  },
  computed: {
    formattedCurrency() {
      return this.$options.filters.currencySymbol(this.currency);
    }
  },
  methods: {
    currencyFormatterWithSymbol(val) {
      const cur = this.isShowCurrencySymbol === false ? '' : this.currency;
      return this.$options.filters.currencyFormatterWithSymbol(val, cur);
    },
    decimalFormat(value) {
      value = Math.round((value + Number.EPSILON) * 1000) / 1000;
      return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 3 });
    },
    generateSymbols() {
      const symbolsData = [];
      for (let i = 0; i < 11; i++) {
        let symbol = {
          id: i,
          image: require(`../../assets/resultGame/oneboxing/s_${i}.png`),
          pays: [
            this.decimalFormat(this.data.config.payTable[i][5]),
            this.decimalFormat(this.data.config.payTable[i][4]),
            this.decimalFormat(this.data.config.payTable[i][3]),
            this.decimalFormat(this.data.config.payTable[i][2])
          ],
          payouts: {
            3: this.decimalFormat(this.data.config.payTable[i][2]),
            4: this.decimalFormat(this.data.config.payTable[i][3]),
            5: this.decimalFormat(this.data.config.payTable[i][4]),
            6: this.decimalFormat(this.data.config.payTable[i][5])
          }
        }
        symbolsData.push(symbol);
      }
      symbolsData.sort((a, b) => b.id - a.id);
      this.symbols = symbolsData;
      return this.symbols;
    },
    getDynamicMargin(id) {
      const maxLength = this.decimalFormat(this.data.config.payTable[id][5]).length;
      let magin = 'calc(29%)'

      if (maxLength < 5) {
        magin = 'calc(26%)'
      } else if (maxLength === 5) {
        magin = 'calc(20%)'
      } else if (maxLength > 5 && maxLength < 7) {
        magin = 'calc(16%)'
      } else if (maxLength >= 7 && maxLength < 9) {
        magin = 'calc(13%)'
      } else if (maxLength >= 9 && maxLength < 11) {
        magin = 'calc(47%)'
      } else {
        magin = 'calc(4%)'
      }

      return {
        marginLeft: magin,
      };
    },
  }
}
</script>

<style scoped>
.paytable-bg {
  background-color: #202020;
  border-radius: 20px;
  padding: 20px;
  margin: 20px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  background-color: #202020;
  border-radius: 20px;
}

.grid-item {
  text-align: center;
  padding-top: 10%;
}

.symbol-image {
  width: clamp(130px, 10vw, 189px);
  margin-right: 20px;
  max-width: 189px;
  min-width: 78px;
}

.payouts {
  margin-top: 10px;
  margin-left: 18%;
}

.payout-row {
  display: flex;
  justify-content: left;
  align-items: left;
}

.symbol-container {
  margin: 5%;
  padding: 5%;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
}

.symbol-content {
  display: flex;
  align-items: center;
}

.special-symbol-image {
  width: 25%;
  margin-right: 20px;
  max-width: 119px;
}

.symbol-info {
  padding-left: 40px;
}

.symbol-info li {
  font-size: 3vw;
}

h2 {
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: bold;
}

.wild-comming-image {
  width: 70%;
  height: auto;
}

.multiplier-image {
  width: 95%;
  height: auto;
}

.freespin-feature-image {
  width: 60%;
  height: auto;
}

.feature-buy-image {
  width: 40%;
  height: auto;
}

.win-line-image {
  width: 70%;
  height: auto;
}

.win-line-container {
  padding: 20px;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
  max-width: 600px;
  margin: auto;
  font-family: 'Arial', sans-serif;
}

h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.win-line-images {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
}

.image-container {
  position: relative;
}

.check {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: green;
}

.cross {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: red;
}

.win-description,
.example,
.extra-info {
  margin: 10px 0;
  font-size: 14px;
}

.payout-table {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.payout-info ul {
  list-style: none;
  padding: 0;
}

.total-win {
  text-align: center;
}

.example-win {
  font-size: 3vw;
  color: #f39c12;
}

.extra-info {
  font-size: 12px;
  margin-top: 20px;
}

.slotmachine-image {
  width: 100%;
  height: auto;
}
</style>

<style>
.bg {
  background: #282828;
}

.game-title {
  font-size: 6vw;
  color: white;
}

.text-title {
  color: #fff;
  font-size: 4vw;
  text-align: center;
}

.sub-text-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
}

.sub-text-gray-payout {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin-left: calc(30%);
}

.sub-text-payout {
  color: #fff;
  font-size: 3vw;
  margin-left: 5%;
  text-align: left;
}

.sub-text-list-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin: 0 auto;
}

.sub-text {
  color: #fff;
  font-size: 3vw;
}

.sub-bg {
  background: #202020;
  border-radius: 30px;
}

.control-table {
  width: 100%;
  border-collapse: collapse;
}

.control-table td {
  border: 3px solid #fff;
  padding: 30px;
  vertical-align: middle;
}

.control-table h3 {
  margin-bottom: 30px;
  font-size: 3vw;
  color: #fff;
}

.control-table p {
  margin: 5px 0 0 0;
  font-size: 3vw;
}

.control-icon {
  width: clamp(78px, 10vw, 150px);
  height: auto;
}

.adjustment-text {
  padding-left: 20%;
  padding-right: 20%;
}

.text-des {
  line-height: 1.5;
}

@media (min-width: 576px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 900px;
  }
}

@media (min-width: 1024px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 1520px;
  }
}

.volatility-image {
  width: 70%;
  height: auto;
}
</style>